export default __webpack_public_path__ + "static/media/PaisajeSoleado.8c6249c7.jpg";